
import CustomInput from "../../components/inputs/CustomInputs";
import {
  Box, Typography, useMediaQuery
} from "@mui/material";
import OneViewBox from "../../components/layouts/OneViewBox";

import SignInButton from "../../components/button/SignInButton";
import DESIGN from "../../assets/images/Group1627.png";
import LOGO from '../../assets/images/lowopacitylogo.png'
import TINNIX from '../../assets/images/Group27.png'

const SignInUI = ({ state, setState, onSubmit, loading }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <OneViewBox
        sx={{ overflow: "hidden", position: "relative", minHeight: "100vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            minHeight: "100vh",
            position: "relative",
          }}
        >
          {isSmallScreen ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
                paddingTop: "80px",
              }}
            >
              <img
                src={TINNIX}
                alt="TINNIX Logo"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: isSmallScreen ? "100%" : "50%",
                position: "relative",
                background: "#d34646",
                clipPath: isSmallScreen
                  ? "ellipse(100% 60% at 50% 90%)"
                  : "ellipse(100% 90% at 0% 72%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
                paddingTop: "80px",
                fontSize: '80px'
              }}
            >
              <img
                src={DESIGN}
                alt="Company Logo"
                style={{ transform: "scale(1.5)", maxWidth: "100%", height: "auto", fontSize: '80px' }}
              />
            </Box>
          )}

          <Box
            sx={{
              width: isSmallScreen ? "100%" : "50%",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2rem",
              zIndex: 1,
              backgroundImage: `url(${LOGO})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Box
              component={"form"}
              width={"100%"}
              onSubmit={onSubmit}
              sx={{ maxWidth: "400px" }}
            >
              <Typography variant="h2" mb={2} color={"#d34646"}>
                Log In
              </Typography>
              <Typography variant="h4" color={"red"} mb={1}>
                {state.err}
              </Typography>
              <Box>
                <Box mb={3}>
                  <CustomInput
                    disabled={loading}
                    value={state.email}
                    onChange={(e) =>
                      setState({ ...state, err: "", email: e.target.value })
                    }
                    type="text"
                    label={"Email"}
                  />
                </Box>
                <CustomInput
                  disabled={loading}
                  value={state.password}
                  onChange={(e) =>
                    setState({ ...state, err: "", password: e.target.value })
                  }
                  type="password"
                  label={"Password"}
                />
              </Box>
              <Box mt={4}>
                <SignInButton
                  loading={loading}
                  disabled={loading}
                  type="submit"
                  title="Sign In"
                  sx={{
                    background: "#d34646",
                    color: "#fff",
                    borderRadius: "30px",
                    padding: "12px 24px",
                    "&:hover": {
                      background: "linear-gradient(90deg,  #d34646, #f2653a)",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </OneViewBox>
    </>
  );
};

export default SignInUI;